<template>
  <div>
    <Card class="landing-card p-4">
      <b-form>
        <ul class="list-unstyled">
          <li v-for="field in fields" :key="field.order">
            <div v-show="field.isVisible">
              <component
                v-bind:is="field.component"
                :field="field"
                v-model="field.value"
                v-bind="field.props"
                @update="onFieldUpdate"
                @input="onInputChange($event, field.id)"
              ></component>
            </div>
          </li>
        </ul>
      </b-form>
    </Card>
    <b-row v-if="this.store.state.editState == null" class="mb-4">
      <b-col class="mt-3" lg="auto" md="12" sm="12" xs="12">
        <Button
          variant="outline-primary"
          @click="onSubmit"
          v-bind:disabled="this.store.state.personaData.length === 6"
          class="btn"
          >Add user type</Button
        >
      </b-col>
      <b-col class="mt-3" lg="auto" md="12" sm="12" xs="12">
        <Button variant="primary " @click="calculateRoi">Calculate</Button>
      </b-col>
    </b-row>
    <div class="row mt-3 mb-4" v-if="this.store.state.editState !== null">
      <div class="col-6">
        <Button variant="outline-primary" @click="onSubmit">Save</Button>
      </div>
      <div class="col-6">
        <Button
          variant="link"
          @click="handleClick"
          style="color:#000; text-decoration:none"
          >Cancel</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '../input-controls/TextField.vue';
import Button from '../input-controls/Button.vue';
import Slider from '../input-controls/Slider.vue';
import RadioField from '../input-controls/RadioField.vue';
import SelectField from '../input-controls/SelectField.vue';
import Card from './Card.vue';
import Toggle from '../global/Toggle.vue';
import store from '../../store';

import * as _ from 'lodash';

export default {
  name: 'Form',
  components: {
    TextField,
    Button,
    Slider,
    RadioField,
    SelectField,
    Card,
    Toggle,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      store,
    };
  },

  methods: {
    calculateRoi() {
      if (store.state.personaData.length === 0) {
        this.onSubmit();
      }
      var myHeaders = new Headers();

      myHeaders.append('Content-Type', 'application/json');

      store.state.personaData.forEach((item, id) => {
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(item),
          redirect: 'follow',
        };
        fetch(`${process.env.VUE_APP_ROOT_API}/api/calculate`, requestOptions)
          .then(response => response.text())
          .then(result => {
            const parsedvalue = _.cloneDeep(JSON.parse(result));
            parsedvalue['id'] = id;
            parsedvalue['regionId'] = item.regionId;
            store.state.personaDataAfterCalculate.push(parsedvalue);
          })
          .catch(error => console.log('error', error));
      });
      this.$watch('store.state.personaDataAfterCalculate', newval => {
        if (newval.length === this.store.state.personaData.length) {
          this.$router.push({ path: '/result' });
        }
      });
    },
    onSubmit() {
      let canSubmit = true;
      const formData = _.cloneDeep(this.fields);
      for (let field of formData) {
        if (field.required && field.value === '') {
          canSubmit = false;
          field.error = 'Field is required';
        }
        if (field.validators) {
          for (let validator of field.validators) {
            if (validator.fn(field.value, field.props)) {
              field.error = validator.msg || 'No validation message present';
              canSubmit = false;
            }
          }
        }
      }

      this.$emit('onSubmit', { formData, canSubmit });
    },

    handleClick() {
      store.clearFormDataAction();
    },

    onFieldUpdate($event) {
      const formData = _.cloneDeep(this.fields);
      const field = _.remove(formData, f => f.id === $event.fieldId).pop();
      field.options = $event.data.map(option => {
        return {
          value: option[field.apiConfig.keys.value],
          text: option[field.apiConfig.keys.text],
        };
      });

      //for adding default values
      // if (field.id === 'vdaMeterId' || field.id === 'userDiskMeterId') {
      // }

      const currRegionId = ['regionId'];
      const filterRegion = _.filter(formData, f =>
        currRegionId.includes(f.id)
      )[0];
      const currPersistenceId = ['persistence'];
      const filterPersistence = _.filter(formData, f =>
        currPersistenceId.includes(f.id)
      )[0];
      if (
        !store.state.task &&
        filterRegion &&
        filterRegion.value !== 'us-east1' &&
        filterPersistence &&
        filterPersistence.value == false
      ) {
        if (
          field.id === 'vdaMeterId' &&
          !field.options.find(el => el.value === 'n2d-standard-8')
        ) {
          field.default = field.options[0].value;
          field.value = field.options[0].value;
        } else if (
          field.id === 'vdaMeterId' &&
          field.options.find(el => el.value === 'n2d-standard-8')
        ) {
          field.default = 'n2d-standard-8';
          field.value = 'n2d-standard-8';
        }
      }

      if (!field.options.find(el => el.value === field.value)) {
        field.default = field.options[0].value;
        field.value = field.options[0].value;
      }

      this.store.setFormData(
        [...formData, field].sort((a, b) => a.order - b.order)
      );
    },

    onInputChange($event, id) {
      $event; // to avoid linting error
      let formData = _.cloneDeep(this.fields);
      const field = _.filter(formData, f => f.id === id).pop();
      if (field.onChangeCb) {
        formData = field.onChangeCb({
          fields: formData,
          curr: field,
        });
        this.store.setFormData(formData);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-card {
  width: 95%;
}
.btn {
  width: 180px;
}
.btn-outline-primary {
  width: 172px;
  font-size: 15px;
  border: 2px solid #05758a;
  border-radius: 26px;
  color: #05758a;
}
.btn-outline-primary:hover {
  background: #fff;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}

@media (max-width: 1280px) {
  .landing-card {
    padding: 25px;
  }
}
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .landing-card {
      width: 425px;
    }
  }
}

/* Safari 10.1+ (alternate method) */

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .landing-card {
      width: 100%;
    }
  }
}
</style>
